import { buildListRoute } from '@/app/arch/components/crud/CrudRouter';

const featureBreadcrumb = [
  {
    text: 'Dashboard',
    disabled: false,
    to: 'dashboard',
  },
  {
    text: 'CardMais',
    disabled: false,
    to: 'contacard.submodules.list',
  },
  {
    text: 'Atualizar taxas do estabelecimento',
    disabled: true,
  },
];

export default [
  buildListRoute({
    baseName: 'establishment',
    basePath: 'establishment',
    component: () => import('@/app/modules/contacard/adq/establishment/EstablishmentForm.vue'),
    baseBreadcrumbs: featureBreadcrumb,
    moduleActive: 'contacard',
    subModuleActive: 'adq',
    card: {
      title: 'Taxas estabelecimento',
      icon: 'home',
    },
  }),
];
